import React from 'react';
import { defineMessage, FormattedMessage } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { Providers } from '../../enums/providers';
import history from '../../history';

export const AmazonTerms2022ErrorCode = 'AmazonTerms2022';

export const NewAmazonTerms2022Message = defineMessage({
  description:
    'Error message indicating the user needs to accept new amazon terms and conditions before printing label using the product Amazon Buy Shipping',
  defaultMessage: 'Amazon Buy Shipping: New terms for Amazon Buy Shipping need to be accepted',
  id: '8FqQkk',
});

export const shouldShowAmazonTermsError = (errorMessageOrArray) => {
  if (Array.isArray(errorMessageOrArray)) {
    return errorMessageOrArray.some(shouldShowAmazonTermsError);
  }
  if (errorMessageOrArray?.defaultMessage) {
    return shouldShowAmazonTermsError(errorMessageOrArray.defaultMessage);
  }
  if (typeof errorMessageOrArray === 'string' || errorMessageOrArray instanceof String) {
    return (
      errorMessageOrArray.includes(AmazonTerms2022ErrorCode) ||
      errorMessageOrArray.localeCompare(NewAmazonTerms2022Message.defaultMessage) === 0
    );
  }
  return false;
};

export const showAmazonTermsErrorNotification = () => {
  const notificationConfig = {
    title: (
      <FormattedMessage
        defaultMessage='Action required'
        description='Title for notification that user needs to accept new amazon terms and conditions before printing label'
        id='9kz9jr'
      />
    ),
    content: (
      <FormattedMessage
        defaultMessage='You must accept new Amazon Buy Shipping terms & conditions.'
        description='Body for notification that user needs to accept new amazon terms and conditions before printing label'
        id='4c+GJY'
      />
    ),
    notificationType: NOTIFICATION_TYPE_ERROR,
    dontHide: true,
  };
  const notificationId = NotificationService.showNotification({
    ...notificationConfig,
  });
  const newNotificationConfig = {
    ...notificationConfig,
    buttons: [
      {
        text: (
          <FormattedMessage
            defaultMessage='View Terms'
            description='Label for notification button that directs the user the new amazon terms and conditions page'
            id='jnBze2'
          />
        ),
        theme: 'link',
        callback: () => {
          history.push(`/tos/${Providers.AmazonBuyShipping.labelProviderId}`);
          NotificationService.removeNotification(notificationId);
        },
      },
    ],
  };
  NotificationService.updateNotification(notificationId, newNotificationConfig);
};
